import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Mail, Lock, AlertCircle, FileText } from 'lucide-react';

const TeamLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.role === 'team_member' || user.role === 'admin') {
        navigate('/admin/team/portal');
      } else {
        setError('Team member access required. Please contact your admin.');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-[#E5E7EB] p-8" data-testid="team-login-form">
          <div className="text-center mb-8">
            <div className="w-14 h-14 mx-auto mb-4 bg-[#0A0A0A] rounded-lg flex items-center justify-center">
              <FileText className="w-7 h-7 text-[#BA1826]" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-[#0A0A0A]">Team Portal</h1>
            <p className="text-sm text-[#4B5563] mt-2">Sign in to submit expenses and trip reports</p>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-6 flex items-center gap-2" data-testid="team-login-error">
              <AlertCircle className="w-5 h-5 flex-shrink-0" />
              <span className="text-sm">{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#4B5563] mb-1">Email</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9CA3AF]" />
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-[#E5E7EB] rounded-sm focus:border-[#BA1826] focus:ring-2 focus:ring-[#BA1826]/10"
                  placeholder="your.email@example.com" required data-testid="team-login-email" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-[#4B5563] mb-1">Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9CA3AF]" />
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-[#E5E7EB] rounded-sm focus:border-[#BA1826] focus:ring-2 focus:ring-[#BA1826]/10"
                  placeholder="Your password" required data-testid="team-login-password" />
              </div>
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-[#BA1826] text-white py-3 rounded-sm font-medium hover:bg-[#9A1420] disabled:opacity-50 transition-colors" data-testid="team-login-submit">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="text-center mt-6">
            <Link to="/" className="text-sm text-[#4B5563] hover:text-[#BA1826]">Back to website</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamLogin;
